__turbopack_context__.v({
  "healthTrackerCard": "ASmX1W_healthTrackerCard",
  "root": "ASmX1W_root",
});
